<template>
    <div class="n2-center-container">
        <div class="n2-margin-top">
            <div class="n2-row">
                <div class="col-md-8 n2-padding">
                    <div>
                        <div v-if="payment_types.includes('P') && shopping_cart.total > 0">
                            <label class="n2-checkbox-lable">
                                <input type="radio" name="payment_method" v-model="selected_payment_method" value="P"
                                    class="n2-checkbox-input" />
                                <span class="n2-checkbox-text">{{ $t('pages.checkout.pay_with_vipps_or_card') }}</span>
                            </label>
                        </div>
                        <div v-if="payment_types.includes('T') || payment_types.includes('M') || payment_types.includes('C')"
                            class="n2-margin-top">
                            <label class="n2-checkbox-lable">
                                <input type="radio" name="payment_method" v-model="selected_payment_method" value="R"
                                    class="n2-checkbox-input" />
                                <span class="n2-checkbox-text">{{ $t('pages.checkout.reserve_with_kolumbus_product')
                                    }}</span>
                            </label>
                            <div v-if="selected_payment_method == 'R'" class="n2-margin-left">
                                <div class="n2-margin-top" v-if="payment_types.includes('T')">
                                    <label class="n2-checkbox-lable">
                                        <input type="radio" name="sub_payment_method"
                                            v-model="sub_selected_payment_method" value="T" class="n2-checkbox-input" />
                                        <span class="n2-checkbox-text">{{
                                            $t('pages.checkout.reserve_with_kolumbus_travel_money') }}</span>
                                    </label>
                                    <div v-if="sub_selected_payment_method == 'T'">
                                        <app-content name="web.checkout.payment_option_travel_money"></app-content>
                                    </div>
                                </div>
                                <div class="n2-margin-top" v-if="payment_types.includes('M')">
                                    <label class="n2-checkbox-lable">
                                        <input type="radio" name="sub_payment_method"
                                            v-model="sub_selected_payment_method" value="M" class="n2-checkbox-input"
                                            v-bind:disabled="checkout.vehicles.length > 0" />
                                        <span class="n2-checkbox-text">{{
                                            $t('pages.checkout.reserve_with_kolumbus_mobile_ticket') }}</span>
                                    </label>
                                    <div v-if="sub_selected_payment_method == 'M'">
                                        <app-content name="web.checkout.payment_option_mobile_ticket"></app-content>
                                    </div>
                                    <div style="font-style: italic; margin-left: 20px;"
                                        v-if="checkout.vehicles.length > 0">
                                        {{ $t('pages.checkout.not_available_due_to_vehicle') }}
                                    </div>
                                </div>
                                <div class="n2-margin-top" v-if="payment_types.includes('C')">
                                    <label class="n2-checkbox-lable">
                                        <input type="radio" name="sub_payment_method"
                                            v-model="sub_selected_payment_method" value="C" class="n2-checkbox-input"
                                            v-bind:disabled="checkout.vehicles.length > 0" />
                                        <span class="n2-checkbox-text">{{
                                            $t('pages.checkout.reserve_with_kolumbus_card') }}</span>
                                    </label>
                                    <div v-if="sub_selected_payment_method == 'C'">
                                        <app-content name="web.checkout.payment_option_kolumbus_card"></app-content>
                                    </div>
                                    <div style="font-style: italic; margin-left: 20px;"
                                        v-if="checkout.vehicles.length > 0">
                                        {{ $t('pages.checkout.not_available_due_to_vehicle') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="payment_types.includes('F')" class="n2-margin-top">
                            <label class="n2-checkbox-lable">
                                <input type="radio" name="payment_method" v-model="selected_payment_method" value="F"
                                    class="n2-checkbox-input" />
                                <span class="n2-checkbox-text">{{ $t('pages.checkout.reserve_free_ferry') }}</span>
                            </label>
                            <div>
                                <app-content name="web.checkout.payment_option_free_ferry"></app-content>
                            </div>
                        </div>
                        <div v-if="payment_types.includes('A')" class="n2-margin-top">
                            <label class="n2-checkbox-lable">
                                <input type="radio" name="payment_method" v-model="selected_payment_method" value="A"
                                    class="n2-checkbox-input" />
                                <span class="n2-checkbox-text">{{ $t('pages.checkout.reserve_auto_pass') }}</span>
                            </label>
                            <div>
                                <app-content name="web.checkout.payment_option_auto_pass"></app-content>
                            </div>
                        </div>
                    </div>
                    <div v-if="form_visible" class="n2-margin-top">
                        <div v-if="checkout.vehicles.length > 0">
                            <h5>{{ $t('pages.checkout.vehicles') }}</h5>
                            <div>
                                <app-content name="web.checkout.vehicle_field_description"></app-content>
                            </div>
                            <div v-for="(v, index) in checkout.vehicles" v-bind:key="v"
                                style="border: 1px solid #cccccc; padding: 10px; margin-top: 10px;">
                                <div>
                                    <div class="n2-form-group">
                                        <label class="n2-form-label">{{ $t('pages.checkout.vehicle') }} {{ index + 1 }}:
                                            {{ getProductName(v.product_id) }}</label>
                                    </div>

                                </div>
                                <div>
                                    <form-input type="text" v-model="v.model"
                                        v-bind:placeholder="$t('pages.checkout.required_field')"
                                        v-bind:label="$t('pages.checkout.make_and_model')"
                                        v-bind:errors="v.model_errors"></form-input>
                                </div>
                                <div>
                                    <form-input type="text" v-model="v.registration_number"
                                        v-bind:placeholder="$t('pages.checkout.required_field')"
                                        v-bind:label="$t('pages.checkout.registration_number')"
                                        v-bind:errors="v.registration_number_errors"></form-input>
                                </div>
                            </div>

                        </div>
                        <div>
                            <h5>{{ $t('pages.checkout.contact_information') }}</h5>
                            <form-input type="text" v-model="checkout.contact.given_name"
                                v-bind:placeholder="$t('pages.checkout.required_field')"
                                v-bind:label="$t('pages.checkout.given_name')"
                                v-bind:errors="model_errors.given_name"></form-input>
                            <form-input type="text" v-model="checkout.contact.family_name"
                                v-bind:placeholder="$t('pages.checkout.required_field')"
                                v-bind:label="$t('pages.checkout.family_name')"
                                v-bind:errors="model_errors.family_name"></form-input>
                            <template v-if="selected_payment_method != 'P'">
                                <form-input type="text" v-model="checkout.contact.address.address_line_1"
                                    v-bind:placeholder="selected_payment_method == 'P' ? '' : $t('pages.checkout.required_field')"
                                    v-bind:label="$t('pages.checkout.address_line_1')"
                                    v-bind:errors="model_errors.address_line_1"></form-input>
                                <form-input type="text" v-model="checkout.contact.address.postal_code"
                                    v-bind:placeholder="selected_payment_method == 'P' ? '' : $t('pages.checkout.required_field')"
                                    v-bind:label="$t('pages.checkout.postal_code')"
                                    v-bind:errors="model_errors.postal_code"></form-input>
                                <form-input type="text" v-model="checkout.contact.address.locality"
                                    v-bind:placeholder="selected_payment_method == 'P' ? '' : $t('pages.checkout.required_field')"
                                    v-bind:label="$t('pages.checkout.locality')"
                                    v-bind:errors="model_errors.locality"></form-input>
                                <div class="n2-form-group">
                                    <label class="n2-form-label">
                                        {{ $t('pages.checkout.country_code') }}
                                    </label>

                                    <app-autocomplete v-model="checkout.contact.address.country_code"
                                        v-bind:items="countries" v-bind:text_field="'name'" v-bind:separator="' '"
                                        v-bind:value_field="'code'"
                                        v-bind:placeholder="selected_payment_method == 'P' ? '' : $t('pages.checkout.required_field')"
                                        v-bind:errors="model_errors.country_code">
                                    </app-autocomplete>
                                </div>
                            </template>
                            <form-input type="text" v-model="checkout.contact.phone_number"
                                v-bind:placeholder="$t('pages.checkout.required_field')"
                                v-bind:label="$t('pages.checkout.phone_number')"
                                v-bind:errors="model_errors.phone_number">
                                <template v-slot:label>
                                    <h1>Here might be a page title</h1>
                                </template>
                            </form-input>
                            <form-input type="text" v-model="checkout.contact.email"
                                v-bind:placeholder="$t('pages.checkout.required_field')"
                                v-bind:label="$t('pages.checkout.email')"
                                v-bind:errors="model_errors.email"></form-input>
                            <!--<form-input type="text" v-model="checkout.contact.email_repeat" v-bind:placeholder="$t('pages.checkout.required_field')" v-bind:label="$t('pages.checkout.email_repeat')" v-bind:errors="model_errors.email_repeat"></form-input>-->
                            <div class="n2-form-group">
                                <label class="n2-form-label" v-html="$t('pages.checkout.email_repeat')"></label>
                                <input type="text" v-on:paste.prevent
                                    v-bind:placeholder="$t('pages.checkout.required_field')"
                                    v-model="checkout.contact.email_repeat" class="n2-input-default"
                                    v-bind:class="{ 'n2-invalid-field': model_errors.email_repeat }" />
                                <ul class="n2-valid" v-bind:class="{ 'n2-errors': model_errors.email_repeat }">
                                    <li v-for="error in model_errors.email_repeat" v-bind:key="error">{{ error }}</li>
                                </ul>
                            </div>

                            <div class="" style="margin-top:10px;">
                                <div v-if="visible_term" style="background-color:#f1f1f1; padding:5px;">
                                    <div style="height: 500px; background-color: #fff; padding: 5px; overflow: scroll;">
                                        <div v-if="visible_term == 'purchase'">
                                            <app-content name="web.term.online_payment"></app-content>

                                        </div>
                                        <div v-if="visible_term == 'reservation'">
                                            <app-content name="web.term.reservation"></app-content>
                                        </div>
                                        <div v-if="visible_term == 'free_ferry'">
                                            <app-content name="web.term.free_ferry"></app-content>
                                        </div>
                                        <div v-if="visible_term == 'auto_pass'">
                                            <app-content name="web.term.auto_pass"></app-content>
                                        </div>
                                    </div>
                                </div>
                                <form-input type="checkbox" v-model="agree_term"
                                    v-bind:errors="model_errors.agree_term">
                                    <template v-slot:inline>
                                        {{ $t('pages.checkout.read_term') }}
                                        <label class="n2-link-1" v-on:click="showTerm('purchase')"
                                            v-if="selected_payment_method == 'P'">{{ $t('pages.checkout.term_purchase')
                                            }}</label>
                                        <label class="n2-link-1" v-on:click="showTerm('reservation')"
                                            v-if="selected_payment_method == 'R'">{{
                                                $t('pages.checkout.term_reservation') }}</label>
                                        <label class="n2-link-1" v-on:click="showTerm('free_ferry')"
                                            v-if="selected_payment_method == 'F'">{{
                                                $t('pages.checkout.term_free_ferry') }}</label>
                                        <label class="n2-link-1" v-on:click="showTerm('auto_pass')"
                                            v-if="selected_payment_method == 'A'">{{
                                                $t('pages.checkout.term_auto_pass') }}</label>
                                    </template>

                                </form-input>
                            </div>
                            <div v-html="$t('pages.checkout.checkout_desc')">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 n2-padding">
                    <shopping-cart></shopping-cart>
                </div>
            </div>
            <div class="n2-padding">
                <validation-summary v-bind:errors="model_errors"></validation-summary>
            </div>
            <div class="n2-padding" style="position:relative;">
                <div v-if="selected_payment_method == 'P'" class="n2-gateways n2-clear">
                    <div v-on:click="nextStep('vipps')" class="n2-left">
                        <img class="n2-btn-payment" v-if="app_locale == 'no'"
                            src="../assets/images/vipps/pay_with_vipps_rect_210_NO.svg" />
                        <img class="n2-btn-payment" v-else
                            src="../assets/images/vipps/pay_with_vipps_rect_210_EN.svg" />
                    </div>
                    <div class="n2-left">
                        <button v-on:click="nextStep('nets')"
                            class="n2-btn-payment n2-btn-payment n2-btn-payment-local">
                            {{ $t('pages.checkout.pay_with_card') }}</button>
                    </div>
                </div>
                <div v-if="selected_payment_method == 'R'">
                    <button class="n2-btn-payment n2-btn-payment-local" v-on:click="nextStep()">{{
                        $t('pages.checkout.reserve_with_kolumbus_product') }}</button>
                </div>
                <div v-if="selected_payment_method == 'F'">
                    <button class="n2-btn-payment n2-btn-payment-local" v-on:click="nextStep()">{{
                        $t('pages.checkout.reserve_free_ferry') }}</button>
                </div>
                <div v-if="selected_payment_method == 'A'">
                    <button class="n2-btn-payment n2-btn-payment-local" v-on:click="nextStep()">{{
                        $t('pages.checkout.reserve_auto_pass') }}</button>
                </div>
                <div class="n2-margin-top">
                    <button class="n2-button-1" v-on:click="previousStep">{{ $t('pages.checkout.previous_step')
                        }}</button>
                </div>
                <app-loader v-bind:active="processing"></app-loader>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ShoppingCartService, CheckoutService, EmailService, SettingService, AccountService } from '../services'
import ShoppingCart from '../components/app/shopping-cart.vue'
import AppAutocomplete from '../components/shared/autocomplete.vue'
import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from "../components/shared/validation-summary.vue"
import AppLoader from '../components/shared/loader.vue'
import AppContent from '../components/shared/content.vue';
import paymentMethods from '../route-payment.json';



import country_list from '../data/country-list'

export default {
    components: {
        AppContent,
        AppAutocomplete, ShoppingCart, FormInput, ValidationSummary, AppLoader,
    },
    data: function () {
        return {
            model_errors: {},
            checkout: {
                contact: {
                    address: {
                        country_code: ''
                    }
                },
                vehicles: [],

            },
            customer: null,
            agree_term: false,
            visible_term: '',
            processing: false,
            payment_types: [],
            selected_payment_method: '',
            sub_selected_payment_method: '',
            form_visible: false,
        }
    },
    computed: {
        ...mapGetters('shopping_cart_store', [
            'shopping_cart'
        ]),
        ...mapGetters('app_settings', [
            'code_challenge'
        ]),
        ...mapGetters('globalization', [
            'app_locale',
            'locale'
        ]),
        ...mapGetters('identity', [
            'authenticated'
        ]),
        ...mapGetters('current_session', [
            'trip_search_query',
            'checkout_token',
            'contact',
            'vehicles'
        ]),
        countries: function () {
            if (this.app_locale == 'no') {
                return country_list.no
            }
            else {
                return country_list.en
            }
        }
    },
    watch: {
        'selected_payment_method': function () {
            if (this.selected_payment_method) {
                this.form_visible = true;

                switch (this.selected_payment_method) {
                    case 'R':
                        switch (this.sub_selected_payment_method) {
                            case 'C':
                                this.shopping_cart.payment_type = 'reservation';
                                break;
                            case 'M':
                                this.shopping_cart.payment_type = 'reservation';
                                break;
                            case 'T':
                                this.shopping_cart.payment_type = 'reservation';
                                break;
                        }
                        break;
                    case 'A':
                    case 'F':
                        this.shopping_cart.payment_type = 'reservation';
                        break;
                    default:
                        this.shopping_cart.payment_type = 'purchase';
                        break;
                }
                this.$store.commit('shopping_cart_store/update', this.shopping_cart)
            }
        },
        'sub_selected_payment_method': function () {
            switch (this.sub_selected_payment_method) {
                case 'C':
                    this.shopping_cart.payment_type = 'reservation';
                    break;
                case 'M':
                    this.shopping_cart.payment_type = 'reservation';
                    break;
                case 'T':
                    this.shopping_cart.payment_type = 'reservation';
                    break;
            }
            this.$store.commit('shopping_cart_store/update', this.shopping_cart)
        },
        'payment_types': function () {
            if (this.payment_types.length == 1) {
                this.selected_payment_method = this.payment_types[0];
                this.form_visible = true;
            }
            else if (this.payment_types.length == 2 && this.payment_types.includes('P') && this.shopping_cart.total == 0) {
                this.selected_payment_method = this.payment_types.filter(a => { return a != 'P' })[0];
                this.form_visible = true;
            }
            else {
                this.form_visible = this.selected_payment_method ? true : false;
            }
        },
        'authenticated': async function (a) {
            if (a) {
                await this.loadCustomer();
            }
        }
    },


    created: function () {
        this.shoppingCartService = new ShoppingCartService();
        this.checkoutService = new CheckoutService();
        this.emailService = new EmailService();
        this.settingService = new SettingService();
        this.accountService = new AccountService();
    },
    mounted: async function () {
        this.checkout.contact = this.contact;
        if (this.authenticated) {
            await this.loadCustomer();
        }
        if (!this.checkout.contact.address.country_code) {
            this.checkout.contact.address.country_code = 'NO'
        }
        let selectedProducts = JSON.parse(this.trip_search_query.products)
        if (selectedProducts) {
            selectedProducts.forEach(p => {
                if (p.product_type == 'vehicle') {
                    //var aa = JSON.parse(p.data)
                    for (let i = 0; i < p.quantity; i++) {
                        let vehicle = {
                            product_id: p.id,
                            model: '',
                            registration_number: ''
                        }
                        if (this.vehicles && this.vehicles.length > 0) {
                            let foundVehicles = this.vehicles.filter(v => v.product_id == p.id)
                            if (foundVehicles && foundVehicles[i]) {
                                vehicle = foundVehicles[i];
                            }
                        }

                        this.checkout.vehicles.push(vehicle)
                    }

                }
            })
        }

        //let setting = await this.settingService.find({ level: 'domain', setting_type: "route_payment_type" });
        let paymentList = paymentMethods;
        if (paymentList.route_payment_types && paymentList.route_payment_types.length > 0) {
            let record = paymentList.route_payment_types.find(p => p.key == this.shopping_cart.legs[0].steps[0].transit.route.name)
            if (record && record.value && this.shopping_cart.legs.length > 1) {
                let recordBackWard = paymentList.route_payment_types.find(p => p.key == this.shopping_cart.legs[1].steps[0].transit.route.name)
                if (record.value.length == 1) {
                    if (recordBackWard.value.length > 1) {
                        record = recordBackWard;
                    }
                }
            }
            this.payment_types = record ? record.value : [];
            if (this.shopping_cart.total > 0) {
                this.payment_types = this.payment_types.filter(p => {
                    return p != 'F' || p != 'A';
                });
            }
        }
    },
    methods: {
        uuid: function () {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        loadCustomer: async function () {
            try {
                let cus = await this.accountService.getDetails();
                if (this.$route.query.previous_step != 'payment_error') {
                    this.checkout.contact = cus;
                    this.checkout.contact.email_repeat = this.checkout.contact.email;
                }
                this.checkout.customer_id = cus.id;
            }
            catch (e) {
                console.log(e);
            }
        },
        getProductName: function (product_id) {
            return this.shopping_cart.product_lines.find(p => p.product_id == product_id).title;
        },
        validatePrice: async function () {
            await this.shoppingCartService.calculate(
                {
                    legs: this.shopping_cart.legs,
                    roundtrip: this.shopping_cart.legs.length > 1 ? true : false
                })
        },
        showTerm: function (name) {
            if (this.visible_term == name) {
                this.visible_term = ''
            }
            else {
                this.visible_term = name
            }
        },
        previousStep: function () {
            return this.$router.push({ path: `/${this.app_locale}/trips`, query: this.trip_search_query })
        },
        nextStep: async function (gateway) {
            //await this.validatePrice()
            if (!this.shopping_cart.legs || this.shopping_cart.legs.length == 0) {
                return;
            }
            if (this.checkout.contact.email_repeat) {
                this.checkout.contact.email_repeat = this.checkout.contact.email_repeat.toLowerCase().trim();
            }
            if (this.checkout.contact.email) {
                this.checkout.contact.email = this.checkout.contact.email.toLowerCase().trim();
            }
            if (this.checkout.contact.phone_number) {
                this.checkout.contact.phone_number = this.checkout.contact.phone_number.toLowerCase().trim();
            }
            if (!this.validateForm(this.selected_payment_method)) {
                return;
            }
            // if (this.authenticated) {
            // }
            this.checkout.locale = this.locale;
            this.checkout.legs = this.shopping_cart.legs;
            this.checkout.app_data = this.shopping_cart.app_data;
            if (this.checkout.contact) {
                if (!this.checkout.contact.customer_type) {
                    this.checkout.contact.customer_type = 'person'
                }
            }
            this.$store.commit('current_session/set_contact', this.checkout.contact);
            this.$store.commit('current_session/set_vehicles', this.checkout.vehicles);
            switch (this.selected_payment_method) {
                case 'R':
                    switch (this.sub_selected_payment_method) {
                        case 'C':
                            this.checkout.template = 'kolumbus_card';
                            this.checkout.payment_type = 'reservation';
                            break;
                        case 'M':
                            this.checkout.template = 'kolumbus_mobile_ticket';
                            this.checkout.payment_type = 'reservation';
                            break;
                        case 'T':
                            this.checkout.template = 'kolumbus_travel_money';
                            this.checkout.payment_type = 'reservation';
                            break;
                    }
                    break;
                case 'F':
                    this.checkout.template = 'free_ferry';
                    this.checkout.payment_type = 'reservation';
                    break;
                case 'A':
                    this.checkout.template = 'auto_pass';
                    this.checkout.payment_type = 'reservation';
                    break;
                default:
                    this.checkout.template = 'online_payment';
                    this.checkout.payment_type = 'purchase';
                    break;

            }

            this.processing = true;
            try {
                var checkoutResult = await this.checkoutService.create(this.checkout)
                this.checkout = checkoutResult
            }
            catch (err) {
                return this.handleError(err);
            }
            finally {
                this.processing = false
            }
            this.processing = true
            switch (this.selected_payment_method) {
                case 'R':
                case 'F':
                case 'A':
                    try {

                        let order = await this.checkoutService.complete(this.checkout.token)
                        try {
                            this.$store.commit('shopping_cart_store/update', {})
                        }
                        catch (e) {
                            console.log(e)
                        }
                        return this.$router.push({
                            path: `/${this.app_locale}/success`,
                            query: {
                                order_id: order.id
                            }
                        })

                    }
                    catch (err) {
                        return this.handleError(err);
                    }
                    finally {
                        this.processing = false
                    }
                default:
                    try {
                        let codeChanllenge = this.uuid()
                        this.$store.commit('app_settings/set_code_challenge', codeChanllenge)
                        let payload = {
                            redirect_url: `${window.location.origin}/${this.app_locale}/landing?checkout_token=${checkoutResult.token}`,
                            gateway: gateway,
                            locale: this.locale,
                            user_id: null,
                            unique_token: this.uuid(),
                            code_challenge: codeChanllenge
                        }
                        var initPaymentResult = await this.checkoutService.initPayment(checkoutResult.token, payload)
                        location.href = initPaymentResult.payment_url
                    }
                    catch {
                        this.processing = false
                        return this.$router.push({ path: `/${this.app_locale}/error/booking_failed` })
                    }
            }

        },

        handleError: function (err) {
            let errorCode = err?.data?.error_code;
            if (errorCode) {
                return this.$router.push({ path: `/${this.app_locale}/error/${errorCode}` })
            }
            else {
                return this.$router.push({ path: `/${this.app_locale}/error/booking_failed` })
            }
        },

        validateForm: function () {
            this.model_errors = {}
            if (!this.checkout.contact.given_name) {
                this.model_errors['given_name'] = [this.$t('pages.checkout.error_given_name')]
            }
            if (!this.checkout.contact.family_name) {
                this.model_errors['family_name'] = [this.$t('pages.checkout.error_family_name')]
            }
            switch (this.selected_payment_method) {
                case 'R':
                    if (!this.sub_selected_payment_method) {
                        this.model_errors['sub_selected_payment_method'] = [this.$t('pages.checkout.error_sub_selected_payment_method')]
                    }
                    break;
                case 'A':
                case 'F':
                    if (!this.checkout.contact.address.address_line_1) {
                        this.model_errors['address_line_1'] = [this.$t('pages.checkout.error_address_line_1')]
                    }
                    if (!this.checkout.contact.address.postal_code) {
                        this.model_errors['postal_code'] = [this.$t('pages.checkout.error_postal_code')]
                    }
                    if (!this.checkout.contact.address.locality) {
                        this.model_errors['locality'] = [this.$t('pages.checkout.error_locality')]
                    }
                    if (!this.checkout.contact.address.country_code) {
                        this.model_errors['country_code'] = [this.$t('pages.checkout.error_country_code')]
                    }

                    break
                default:
            }

            let patternPhone = new RegExp(/^([+]{0,1})((?:\s*\d){8,})$/)
            if (!patternPhone.test(this.checkout.contact.phone_number)) {
                this.model_errors['phone_number'] = [this.$t('pages.checkout.error_phone_number')]
            }
            let patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!patternEmail.test(this.checkout.contact.email)) {
                this.model_errors['email'] = [this.$t('pages.checkout.error_email')]
            }
            if (this.checkout.contact.email != this.checkout.contact.email_repeat) {
                this.model_errors['email_repeat'] = [this.$t('pages.checkout.error_email_repeat')]
            }


            if (!this.agree_term) {
                this.model_errors['agree_term'] = [this.$t('pages.checkout.error_agree_term')]
            }

            this.checkout.vehicles.forEach(v => {
                v.model_errors = null;
                v.registration_number_errors = null;
                var result = true
                if (!/(.*[a-z]){3}/i.test(v.model)) {
                    result = false
                }
                if (v.model.length < 4) {
                    result = false
                }
                if (!result) {
                    v.model_errors = [this.$t('pages.checkout.error_vehicle_model')]
                }

                var numberResult = true
                if (v.registration_number.length < 2) {
                    numberResult = false
                }
                if (!numberResult) {
                    v.registration_number_errors = [this.$t('pages.checkout.error_vehicle_registration_number')]
                }

                if (!result || !numberResult) {
                    this.model_errors['vehicle_info'] = [this.$t('pages.checkout.error_vehicle_info')]
                }
            })
            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        }


    }
}
</script>
